// Builders de payload para os endpoints atômicos "completo" do CRM (funil e
// régua). Derivam `ordem` da posição no array e preservam o `id` dos itens
// existentes (o backend faz diff-upsert por id na edição). Extraídos das APIs
// pra ficarem testáveis isoladamente.

// Converte campo numérico opcional preservando 0 (diferente do idiom
// `valor || null`, que apagaria "sinalizar no mesmo dia").
function toOptionalInt(valor) {
  if (valor === undefined || valor === null || valor === '') return null
  return Number(valor)
}

// Funil completo: funil + etapas + atividades aninhadas.
export function buildFunilCompletoPayload({ funil, etapas } = {}) {
  const etapasFormatadas = (etapas || []).map((etapa, indiceEtapa) => {
    const etapaPayload = {
      nome: etapa.nome,
      descricao: etapa.descricao || null,
      ordem: indiceEtapa,
      ativo: etapa.ativo === undefined ? true : Boolean(etapa.ativo),
      probabilidade_fechamento: etapa.probabilidade_fechamento || null,
      probabilidade_progresso: etapa.probabilidade_progresso || null,
      dias_estimados: etapa.dias_estimados || null,
      dias_atencao: toOptionalInt(etapa.dias_atencao),
      dias_critico: toOptionalInt(etapa.dias_critico),
      atividades: (etapa.atividades || []).map((atividade, indiceAtividade) => {
        const atividadePayload = {
          nome: atividade.nome,
          descricao: atividade.descricao || null,
          texto_sugerido: atividade.texto_sugerido || null,
          tipo: atividade.tipo,
          ordem: indiceAtividade,
          ativo: atividade.ativo === undefined ? true : Boolean(atividade.ativo),
          dias_estimados: atividade.dias_estimados || null,
          obrigatorio: Boolean(atividade.obrigatorio),
        }
        if (atividade.id) atividadePayload.id = atividade.id
        return atividadePayload
      }),
    }
    if (etapa.id) etapaPayload.id = etapa.id
    return etapaPayload
  })

  // 'ativo' NÃO entra no payload: não existe toggle de UI pra esse campo no builder, e o
  // backend nunca devolvia o valor real na listagem (bug), então qualquer valor local aqui
  // seria sempre stale. O backend agora preserva o 'ativo' atual quando a chave não vem.
  return {
    nome: (funil && funil.nome) || '',
    descricao: (funil && funil.descricao) || null,
    etapas: etapasFormatadas,
  }
}

// Régua completa: régua (1 nível) + atividades. Atividade usa `frequencia_dias`
// (recorrência); a régua pode ter `id_segmentacao`.
export function buildReguaCompletoPayload({ regua, atividades } = {}) {
  const atividadesFormatadas = (atividades || []).map((atividade, indice) => {
    const atividadePayload = {
      nome: atividade.nome,
      tipo: atividade.tipo,
      conteudo: atividade.conteudo || null,
      texto_sugerido: atividade.texto_sugerido || null,
      frequencia_dias:
        atividade.frequencia_dias === undefined ||
        atividade.frequencia_dias === null ||
        atividade.frequencia_dias === ''
          ? null
          : Number(atividade.frequencia_dias),
      ordem: indice,
    }
    if (atividade.id) atividadePayload.id = atividade.id
    return atividadePayload
  })

  return {
    nome: (regua && regua.nome) || '',
    descricao: (regua && regua.descricao) || null,
    id_segmentacao:
      regua && regua.id_segmentacao !== undefined ? regua.id_segmentacao : null,
    ativo: regua && regua.ativo !== undefined ? Boolean(regua.ativo) : true,
    atividades: atividadesFormatadas,
  }
}
